import React from 'react';
import moment from 'moment';
import { apiGet } from '../../../../services/apiClient';
import { getRoles } from '../../../../services/userRights';
import CheckBoxInput from '../../../../controls/checkBoxInput.jsx';
import DateTimeInput from '../../../../controls/dateTimeInput.jsx';
import DateTimeLabel from '../../../../controls/dateTimeLabel.jsx';
import NumberInput from '../../../../controls/numberInput.jsx';
import SelectInput from '../../../../controls/selectInput.jsx';
import TextInput from '../../../../controls/textInput.jsx';
import { isUndefined } from 'util';

export default class CargoTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            carriers: [],
            vehicleTypes: [],
            urgencies: [],
            departamentworkinghours: [],
            courierDeliveryId: null,
            parcelDocType: -1,
            parcelCargoType: -2
        };
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    initParcelData(parcel) {
        parcel.authorName = "";
        parcel.cargoDescription = "";
        parcel.carrierId = null;
        parcel.declaredCargoValue = "";
        parcel.deliveryTime = null;
        parcel.departureDate = null;
        parcel.externalNumber = "";
        parcel.isDeliveryTimeSpecified = false;
        parcel.isLoadingRequested = false;
        parcel.isPackagingRequested = false;
        parcel.packagingComment = '';
        parcel.isProductSending = false;
        parcel.isReturnRequested = false;
        parcel.isValueDeclared = false;
        parcel.isTempConditionRequested = false;
        parcel.isSelfDelivery = false;
        parcel.departamentWorkingHoursId = null;
        parcel.parcelType = null;
        parcel.senderComment = "";
        parcel.tempConditionHigh = "";
        parcel.tempConditionLow = "";
        parcel.deliveryCost = "";
        parcel.urgencyId = null;
        parcel.vehicleTypeId = null;
        parcel.packagesCount = "";
        parcel.length = "";
        parcel.width = "";
        parcel.height = "";
        parcel.volume = "";
        parcel.weight = "";
        parcel.invoiceNumber = "";

        this.state.urgencies.map((entry, ind, array) => {
            if (entry.label === 'Стандарт') {
                parcel.urgencyId = entry.value;
            }
        });

        this.updateBusyCount(1);
        apiGet('user/info')
            .then(data => {
                this.updateBusyCount(-1);
                let surname = data.surname ? data.surname : "";
                let name = data.name ? data.name : "";
                let patronymic = data.patronymic ? data.patronymic : "";
                this.props.onFieldChange([{
                    name: "authorName",
                    value: surname + ' ' + name + ' ' + patronymic
                }]);
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('parcels/nextday')
            .then(data => {
                this.updateBusyCount(-1);
                this.props.onFieldChange([{
                    name: "departureDate",
                    value: data.departureDate
                }]);
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        return parcel;
    }

    reloadReferences() {
        this.updateBusyCount(1);
        let loadTypes = apiGet('ref/parceltypes/list')
            .then(data => {
                this.updateBusyCount(-1);

                var docTypeValue = 0;
                var cargoTypeValue = 0;
                data.entries.map((entry, ind, array) => {
                    if (entry.name === "Document") {
                        docTypeValue = entry.id;
                    } else if (entry.name === "Cargo") {
                        cargoTypeValue = entry.id;
                    }
                });

                this.setState((prevState, props) => {
                    prevState.parcelDocType = docTypeValue;
                    prevState.parcelCargoType = cargoTypeValue;
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        let loadCarriers = apiGet('ref/carriers/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.carriers = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        let loadVehicleTypes = apiGet('ref/vehicletypes/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.vehicleTypes = data.entries.map((entry, ind, array) => {
                        if (entry.name === 'Курьерская доставка (без режима)') {
                            prevState.courierDeliveryId = entry.id;
                        }
                        return { value: entry.id, label: entry.name };
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        let loadUrgencies = apiGet('ref/urgencies/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    var standardId = null;
                    prevState.urgencies = data.entries.map((entry, ind, array) => {
                        if (entry.name === 'Стандарт') {
                            standardId = entry.id;
                        }
                        return { value: entry.id, label: entry.name };
                    });
                    if (this.props.isNew) {
                        this.handleInputChange("urgencyId", standardId);
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        let loadDepartamentWorkingHours = null;
        let shipmentAddress = this.props.parcel.shipmentAddress;
        if (shipmentAddress) {
            let city = null;
            if (shipmentAddress.city) {
                city = shipmentAddress.city;
            } else if (shipmentAddress.region) {
                city = shipmentAddress.region;
            }
            if (city) {
				this.updateBusyCount(1);
                loadDepartamentWorkingHours = apiGet('ref/departamentworkinghours/list/' + city)
                    .then(data => {
                        this.updateBusyCount(-1);
                        this.setState((prevState, props) => {
                            prevState.departamentworkinghours = data.entries.map((entry, ind, array) => {
                                let label = entry.city + ", " + entry.postalCode + ", " + entry.address;
                                return { value: entry.id, label: label, schedule: entry.schedule, contactInfo: entry.contactInfo };
                            });

                            if (this.props.parcel.id == undefined || this.props.parcel.id == null) {
	                            if (prevState.departamentworkinghours.length > 0) { 
		                            this.props.parcel.departamentWorkingHoursId = prevState.departamentworkinghours[0].value;
	                            } else {
		                            this.props.parcel.departamentWorkingHoursId = null;
	                            }
                            }
                            return prevState;
                        });
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                    });
            }
        }

        return Promise.all([loadTypes, loadCarriers, loadVehicleTypes, loadUrgencies, loadDepartamentWorkingHours]);
    }

    fillModel(parcel) {
        parcel.cargoDescription = this.replaceEmptyString(this.props.parcel.cargoDescription);
        parcel.carrierId = this.props.parcel.carrierId;
        parcel.declaredCargoValue = this.getNumber(this.props.parcel.declaredCargoValue);
        parcel.deliveryTime = this.getDateTimeStr(this.props.parcel.deliveryTime);
        parcel.departureDate = this.getDateTimeStr(this.props.parcel.departureDate);
        parcel.isDeliveryTimeSpecified = this.props.parcel.isDeliveryTimeSpecified;
        parcel.isLoadingRequested = this.props.parcel.isLoadingRequested;
        parcel.isPackagingRequested = this.props.parcel.isPackagingRequested;
        parcel.packagingComment = this.props.parcel.packagingComment;
        parcel.isProductSending = this.props.parcel.isProductSending;
        parcel.isReturnRequested = this.props.parcel.isReturnRequested;
        parcel.isValueDeclared = this.props.parcel.isValueDeclared;
        parcel.isTempConditionRequested = this.props.parcel.isTempConditionRequested;
        parcel.parcelType = this.props.parcel.parcelType;
        parcel.isSelfDelivery = this.props.parcel.isSelfDelivery;
        parcel.departamentWorkingHoursId = this.props.parcel.departamentWorkingHoursId;
        parcel.senderComment = this.replaceEmptyString(this.props.parcel.senderComment);
        parcel.tempConditionHigh = this.getInt(this.props.parcel.tempConditionHigh);
        parcel.tempConditionLow = this.getInt(this.props.parcel.tempConditionLow);
        parcel.deliveryCost = this.getNumber(this.props.parcel.deliveryCost);
        parcel.urgencyId = this.props.parcel.urgencyId;
        parcel.vehicleTypeId = this.props.parcel.vehicleTypeId;
        parcel.packagesCount = this.getNumber(this.props.parcel.packagesCount);
        parcel.length = this.getNumber(this.props.parcel.length);
        parcel.width = this.getNumber(this.props.parcel.width);
        parcel.height = this.getNumber(this.props.parcel.height);
        parcel.volume = this.getNumber(this.props.parcel.volume);
        parcel.weight = this.getNumber(this.props.parcel.weight);
        parcel.invoiceNumber = this.replaceEmptyString(this.props.parcel.invoiceNumber);
        return parcel;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors)
            && (errors.cargoDescription
                || errors.carrierId
                || errors.declaredCargoValue
                || errors.deliveryTime
                || errors.departureDate
                || errors.isDeliveryTimeSpecified
                || errors.isLoadingRequested
                || errors.isPackagingRequested
                || errors.packagingComment
                || errors.isProductSending
                || errors.isReturnRequested
                || errors.isValueDeclared
                || errors.isTempConditionRequested
                || errors.parcelType
                || errors.senderComment
                || errors.tempConditionHigh
                || errors.tempConditionLow
                || errors.deliveryCost
                || errors.urgencyId
                || errors.vehicleTypeId
                || errors.invoiceNumber
                || errors.packagesCount
                || errors.length
                || errors.width
                || errors.height
                || errors.volume
                || errors.weight);
    }

    validateForm(fieldName) {
        var result = null;

        if (isUndefined(fieldName) || fieldName === "parcelType") {
            if (this.props.parcel.parcelType !== this.state.parcelDocType && this.props.parcel.parcelType !== this.state.parcelCargoType) {
                result = result ? result : {};
                result.parcelType = "Тип посылки является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "cargoDescription") {
            if (this.isEmptyString(this.props.parcel.cargoDescription)) {
                result = result ? result : {};
                result.cargoDescription = "Описание содержимого является обязательным полем";
            } else if (this.props.parcel.cargoDescription.length > 1000) {
                result = result ? result : {};
                result.cargoDescription = "Длина поля Описание содержимого не должна превышать 1000 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "senderComment") {
            if (!this.isEmptyString(this.props.parcel.senderComment) && this.props.parcel.senderComment.length > 1000) {
                result = result ? result : {};
                result.senderComment = "Длина поля Комментарий к грузу не должна превышать 1000 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "invoiceNumber") {
            if (!this.isEmptyString(this.props.parcel.invoiceNumber) && this.props.parcel.invoiceNumber.length > 20) {
                result = result ? result : {};
                result.invoiceNumber = "Длина поля Счет не должна превышать 20 символов";
            }
        }

        if (isUndefined(fieldName) || fieldName === "weight") {
            if (this.isEmptyString(this.props.parcel.weight) || this.isNotNumber(this.props.parcel.weight)) {
                result = result ? result : {};
                result.weight = "Вес является обязательным полем";
            } else if (this.props.parcel.weight > 1e10) {
                result = result ? result : {};
                result.weight = "Некорректное значение поля Вес";
            }
        }

        if (isUndefined(fieldName) || fieldName === "volume") {
            if (this.isEmptyString(this.props.parcel.volume) || this.isNotNumber(this.props.parcel.volume)) {
                result = result ? result : {};
                result.volume = "Объём является обязательным полем";
            } else if (this.props.parcel.volume > 1e10) {
                result = result ? result : {};
                result.volume = "Некорректное значение поля Объём";
            }
        }

        if (this.props.parcel.parcelType === this.state.parcelCargoType) {
            if (isUndefined(fieldName) || fieldName === "packagesCount") {
                if (this.isEmptyString(this.props.parcel.packagesCount) || this.isNotNumber(this.props.parcel.packagesCount)) {
                    result = result ? result : {};
                    result.packagesCount = "Количество грузовых мест является обязательным полем";
                } else if (this.props.parcel.packagesCount > 1e10) {
                    result = result ? result : {};
                    result.packagesCount = "Некорректное значение поля Количество грузовых мест";
                }
            }

            if (isUndefined(fieldName) || fieldName === "length") {
                if (this.isEmptyString(this.props.parcel.length) || this.isNotNumber(this.props.parcel.length)) {
                    result = result ? result : {};
                    result.length = "Нужно указать все габариты";
                } else if (this.props.parcel.length > 1e10) {
                    result = result ? result : {};
                    result.length = "Некорректное значение поля Длина";
                }
            }

            if (isUndefined(fieldName) || fieldName === "width") {
                if (this.isEmptyString(this.props.parcel.width) || this.isNotNumber(this.props.parcel.width)) {
                    result = result ? result : {};
                    result.width = "Нужно указать все габариты";
                } else if (this.props.parcel.width > 1e10) {
                    result = result ? result : {};
                    result.width = "Некорректное значение поля Ширина";
                }
            }

            if (isUndefined(fieldName) || fieldName === "height") {
                if (this.isEmptyString(this.props.parcel.height) || this.isNotNumber(this.props.parcel.height)) {
                    result = result ? result : {};
                    result.height = "Нужно указать все габариты";
                } else if (this.props.parcel.height > 1e10) {
                    result = result ? result : {};
                    result.height = "Некорректное значение поля Высота";
                }
            }
        }

        if (isUndefined(fieldName) || fieldName === "declaredCargoValue") {
            let isNotValidNumber = this.isEmptyString(this.props.parcel.declaredCargoValue) || this.isNotNumber(this.props.parcel.declaredCargoValue);
            if (this.props.parcel.isValueDeclared && isNotValidNumber) {
                result = result ? result : {};
                result.declaredCargoValue = "Стоимость груза является обязательным полем";
            } else if (this.props.parcel.declaredCargoValue > 1e10) {
                result = result ? result : {};
                result.declaredCargoValue = "Некорректное значение поля Стоимость груза";
            }
        }

        if (isUndefined(fieldName) || fieldName === "departureDate") {
            if (!this.props.parcel.departureDate) {
                result = result ? result : {};
                result.departureDate = "Дата отправки груза является обязательным полем";
            } else if (moment(this.props.parcel.departureDate).isBefore('1900-01-01')) {
                result = result ? result : {};
                result.departureDate = "Дата отправки груза имеет некорректное значение";
            }
        }

        if (isUndefined(fieldName)) {
            if (this.props.parcel.departureDate
                && this.props.parcel.deliveryTime
                && moment(this.props.parcel.departureDate) > moment(this.props.parcel.deliveryTime)) {
                result = result ? result : {};
                result.departureDate = "Желаемая дата и время доставки не может быть раньше Даты отправки груза";
            }
        }

        if (isUndefined(fieldName) || fieldName === "vehicleTypeId") {
            if (!this.props.isNew && !this.props.parcel.vehicleTypeId) {
                result = result ? result : {};
                result.vehicleTypeId = "Тип ТС является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "packagingComment") {
            if (this.props.parcel.isPackagingRequested && !this.props.parcel.packagingComment) {
                result = result ? result : {};
                result.packagingComment = "Комментарий к услуге допупаковки является обязательным полем";
            }
        }

        if (this.props.parcel.isTempConditionRequested) {
            if (isUndefined(fieldName) || fieldName === "tempConditionLow") {
                if (this.isEmptyString(this.props.parcel.tempConditionLow) && this.isEmptyString(this.props.parcel.tempConditionHigh)) {
                    result = result ? result : {};
                    result.tempConditionLow = "Не указаны границы терморежима";
                } else if (this.isEmptyString(this.props.parcel.tempConditionLow) && !this.isEmptyString(this.props.parcel.tempConditionHigh)) {
                    result = result ? result : {};
                    result.tempConditionLow = "Нужно указать обе границы терморежима";
                } else if (!this.isEmptyString(this.props.parcel.tempConditionLow) && this.props.parcel.tempConditionLow > 2e9) {
                    result = result ? result : {};
                    result.tempConditionLow = "Некорректное значение нижней границы терморежима";
                } else if (!this.isEmptyString(this.props.parcel.tempConditionLow) && !this.isEmptyString(this.props.parcel.tempConditionHigh)) {
                    let tempConditionLow = parseFloat(this.props.parcel.tempConditionLow);
                    let tempConditionHigh = parseFloat(this.props.parcel.tempConditionHigh);
                    if (tempConditionLow > tempConditionHigh) {
                        result = result ? result : {};
                        result.tempConditionLow = "Нижняя граница не может быть больше верхней";
                    }
                }
            }

            if (isUndefined(fieldName) || fieldName === "tempConditionHigh") {
                if (this.isEmptyString(this.props.parcel.tempConditionLow) && this.isEmptyString(this.props.parcel.tempConditionHigh)) {
                    result = result ? result : {};
                    result.tempConditionHigh = "Не указаны границы терморежима";
                } else if (!this.isEmptyString(this.props.parcel.tempConditionLow) && this.isEmptyString(this.props.parcel.tempConditionHigh)) {
                    result = result ? result : {};
                    result.tempConditionHigh = "Нужно указать обе границы терморежима";
                } else if (!this.isEmptyString(this.props.parcel.tempConditionHigh) && this.props.parcel.tempConditionHigh > 2e9) {
                    result = result ? result : {};
                    result.tempConditionHigh = "Некорректное значение верхней границы терморежима";
                } else if (!this.isEmptyString(this.props.parcel.tempConditionLow) && !this.isEmptyString(this.props.parcel.tempConditionHigh)) {
                    let tempConditionLow = parseFloat(this.props.parcel.tempConditionLow);
                    let tempConditionHigh = parseFloat(this.props.parcel.tempConditionHigh);
                    if (tempConditionLow > tempConditionHigh) {
                        result = result ? result : {};
                        result.tempConditionHigh = "Нижняя граница не может быть больше верхней";
                    }
                }
            }
        }

        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    isNotNumber(value) {
        let parsedValue = parseFloat(value);
        return !parsedValue || isNaN(parsedValue);
    }

    getNumber(str) {
        var clearStr = this.replaceEmptyString(str);
        if (clearStr !== null) {
            var parsedNum = parseFloat(clearStr);
            if (!isNaN(parsedNum)) {
                return parsedNum;
            }
        }
        return null;
    }

    getInt(str) {
        var clearStr = this.replaceEmptyString(str);
        if (clearStr !== null) {
            var parsedNum = parseInt(clearStr);
            if (!isNaN(parsedNum)) {
                return parsedNum;
            }
        }
        return null;
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    getDateTimeStr(value) {
        if (value) {
            return moment(value).format('YYYY-MM-DDTHH:mm:ss');
        } else {
            return null;
        }
    }

    syncVolume() {
        let length = this.getNumber(this.props.parcel.length);
        let width = this.getNumber(this.props.parcel.width);
        let height = this.getNumber(this.props.parcel.height);
        if (length !== null && width !== null && height !== null) {
            let volume = this.getVolume(length, width, height);
            this.handleInputChange("volume", "" + volume);
        } else {
            this.handleInputChange("volume", "");
        }
    }

    getVolume(length, width, height) {
        let volume = length * width * height / 1000000;
        volume = Math.round(volume * 100000) / 100000;
        if (volume < 0.00001) {
            volume = 0.00001;
        }

        return volume;
    }

    handleInputChange(name, newValue) {
        return this.props.onFieldChange([
            {
                name: name,
                value: newValue
            }
        ]).then(() => {
            if (this.props.isNew && (name === "length" || name === "width" || name === "height")) {
                this.syncVolume();
            }
            return Promise.resolve();
        });
    }

    handleCheckboxChange(name, newValue) {
        this.handleInputChange(name, newValue)
            .then(() => this.handleFieldEdited(name, newValue));
    }

    handleParcelTypeChange(event) {
        let parcelType = parseInt(event.target.value);
        let newFieldValues = [
            {
                name: "parcelType",
                value: parcelType
            },
            {
                name: "vehicleTypeId",
                value: this.state.courierDeliveryId
            }
        ];

        if (parcelType === this.state.parcelDocType) {
            newFieldValues.push({
                name: "weight",
                value: 0.1
            });
            newFieldValues.push({
                name: "volume",
                value: 0.0015
            });
            newFieldValues.push({
                name: "vehicleTypeId",
                value: this.state.courierDeliveryId
            });
            newFieldValues.push({
                name: "isLoadingRequested",
                value: false
            });
            newFieldValues.push({
                name: "isValueDeclared",
                value: false
            });
            newFieldValues.push({
                name: "isPackagingRequested",
                value: false
            });
            newFieldValues.push({
                name: "packagingComment",
                value: null
            });
            newFieldValues.push({
                name: "isProductSending",
                value: false
            });
            newFieldValues.push({
                name: "isTempConditionRequested",
                value: false
            });
            newFieldValues.push({
                name: "tempConditionLow",
                value: null
            });
            newFieldValues.push({
                name: "tempConditionHigh",
                value: null
            });
            newFieldValues.push({
                name: "length",
                value: null
            });
            newFieldValues.push({
                name: "width",
                value: null
            });
            newFieldValues.push({
                name: "height",
                value: null
            });
        } else if (parcelType === this.state.parcelCargoType) {
            newFieldValues.push({
                name: "weight",
                value: null
            });
            newFieldValues.push({
                name: "volume",
                value: this.getVolume(10, 10, 10)
            });
            newFieldValues.push({
                name: "length",
                value: 10
            });
            newFieldValues.push({
                name: "width",
                value: 10
            });
            newFieldValues.push({
                name: "height",
                value: 10
            });
            newFieldValues.push({
                name: "packagesCount",
                value: 1
            });
        }

        this.props.onFieldChange(newFieldValues)
            .then(() => this.handleFieldEdited("parcelType", parcelType));
    }

    handleSelectionChange(name, selection) {
        let value = selection ? selection.value : null;
        this.handleInputChange(name, value)
            .then(() => this.handleFieldEdited(name, value));
    }

    handleFieldEdited(name, value) {
        if (this.props.onFieldEdited) {
            if (isUndefined(value)) {
                value = this.props.parcel[name];
            }
            this.props.onFieldEdited(name, value);
        }
    }

    renderDimensions(isDisabled) {
        if (this.props.parcel.parcelType === this.state.parcelCargoType) {
            return (
                <div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className={"form-group" + (this.props.errors.packagesCount ? " has-error" : "")}>
                                <label htmlFor="inputPackagesCount">Количество грузовых мест<span className="text-red">*</span></label>
                                <NumberInput id="inputPackagesCount"
                                    title={this.props.errors.packagesCount}
                                    value={this.props.parcel.packagesCount}
                                    decimals="0"
                                    min="1"
                                    onChange={value => this.handleInputChange("packagesCount", value)}
                                    onEditComplete={() => this.handleFieldEdited("packagesCount")}
                                    disabled={isDisabled}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <label>Суммарные габариты:</label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4">
                            <div className={"form-group" + (this.props.errors.length ? " has-error" : "")}>
                                <label htmlFor="inputLength">Длина<span className="text-red">*</span></label>
                                <div className="input-group">
                                    <NumberInput id="inputLength"
                                        title={this.props.errors.length}
                                        value={this.props.parcel.length}
                                        decimals="1"
                                        min="0"
                                        onChange={value => this.handleInputChange("length", value)}
                                        onEditComplete={() => this.handleFieldEdited("length")}
                                        disabled={isDisabled}
                                    />
                                    <span className="input-group-addon">см</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className={"form-group" + (this.props.errors.width ? " has-error" : "")}>
                                <label htmlFor="inputWidth">Ширина<span className="text-red">*</span></label>
                                <div className="input-group">
                                    <NumberInput id="inputWidth"
                                        title={this.props.errors.width}
                                        value={this.props.parcel.width}
                                        decimals="1"
                                        min="0"
                                        onChange={value => this.handleInputChange("width", value)}
                                        onEditComplete={() => this.handleFieldEdited("width")}
                                        disabled={isDisabled}
                                    />
                                    <span className="input-group-addon">см</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className={"form-group" + (this.props.errors.height ? " has-error" : "")}>
                                <label htmlFor="inputHeight">Высота<span className="text-red">*</span></label>
                                <div className="input-group">
                                    <NumberInput id="inputHeight"
                                        title={this.props.errors.height}
                                        value={this.props.parcel.height}
                                        decimals="1"
                                        min="0"
                                        onChange={value => this.handleInputChange("height", value)}
                                        onEditComplete={() => this.handleFieldEdited("height")}
                                        disabled={isDisabled}
                                    />
                                    <span className="input-group-addon">см</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderShipmentDate(isBusy) {
        if (isBusy) {
            return (
                <DateTimeLabel id="inputDepartureDate"
                    enableTime={false}
                    value={this.props.parcel.departureDate}
                    title={this.props.errors.departureDate}
                />
            );
        } else {
            return (
                <DateTimeInput id="inputDepartureDate"
                    enableTime={false}
                    openDirection="up"
                    onChange={value => this.handleInputChange("departureDate", value)}
                    onEditComplete={() => this.handleFieldEdited("departureDate")}
                    value={this.props.parcel.departureDate}
                    title={this.props.errors.departureDate}
                    disabled={isBusy}
                />
            );
        }
    }

    renderDeclaredCargoValue(disabled) {
        if (this.props.parcel.isValueDeclared) {
            return (
                <div className={this.props.errors.declaredCargoValue ? " has-error" : ""}>
                    <div className="input-group">
                        <NumberInput id="inputDeclaredCargoValue"
                            title={this.props.errors.declaredCargoValue}
                            value={this.props.parcel.declaredCargoValue}
                            decimals="2"
                            min="0"
                            onChange={value => this.handleInputChange("declaredCargoValue", value)}
                            onEditComplete={() => this.handleFieldEdited("declaredCargoValue")}
                            disabled={disabled}
                        />
                        <span className="input-group-addon">₽</span>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderIsSelfDelivery(disabled) {
        if (this.props.parcel.isSelfDelivery) {
	        let departament = null;
            if (this.state.departamentworkinghours.length === 1) {
                departament = this.state.departamentworkinghours[0];
                return (
                    <div>
                        <span>Адрес ТК: {departament.label}</span><br/>
                        <span>Часы работы: {departament.schedule}</span><br />
                        <span>Контакты: {departament.contactInfo}</span><br />
                        <span><b>Не забудьте накладную.</b></span>
                    </div>
                );
            } else if (this.state.departamentworkinghours.length > 1) {
                departament = this.state.departamentworkinghours.find(el => el.value === this.props.parcel.departamentWorkingHoursId);
                return (
                    <div className="form-group">
                        <label>Офис:</label>
                        <SelectInput id="selectDepartamentWorkingHours"
                            clearable={false}
                            options={this.state.departamentworkinghours}
                            value={this.props.parcel.departamentWorkingHoursId}
                            onChange={e => this.handleSelectionChange("departamentWorkingHoursId", e)}
                            disabled={disabled}
                        />
                        {this.renderDepartamentInfo(departament)}
                    </div>
                );
            }
        } else {
            return null;
        }
    }

    renderDepartamentInfo(departament) {
	    if (!departament)
		    return null;
	    else
            return (
	            <div>
		            <span>Часы работы: {departament.schedule}</span><br />
		            <span>Контакты: {departament.contactInfo}</span><br />
		            <span><b>Не забудьте накладную.</b></span>
	            </div>
	    );
    }

    renderTempConditionCheckbox(disabled) {
        return (
            <div className="col-sm-12">
                <label>
                    <CheckBoxInput id="inputIsTempConditionRequested"
                        title={this.props.errors.isTempConditionRequested}
                        checked={this.props.parcel.isTempConditionRequested}
                        onChange={e => this.handleCheckboxChange("isTempConditionRequested", e)}
                        disabled={disabled}
                    />
                    Терморежим
                </label>
            </div>
        );
    }

    renderTempConditionControls(disabled) {
        if (this.props.parcel.isTempConditionRequested) {
            return (
                <div className="row checkbox">
                    {this.renderTempConditionCheckbox(disabled)}
                    <div className={"col-xs-2 col-sm-1 inline-label" + (this.props.errors.tempConditionLow ? " has-error" : "")}>
                        от
                    </div>
                    <div className={"col-xs-10 col-sm-5" + (this.props.errors.tempConditionLow ? " has-error" : "")}>
                        <div className="input-group">
                            <NumberInput id="inputTempConditionLow"
                                title={this.props.errors.tempConditionLow}
                                value={this.props.parcel.tempConditionLow}
                                decimals="0"
                                onChange={value => this.handleInputChange("tempConditionLow", value)}
                                onEditComplete={() => this.handleFieldEdited("tempConditionLow")}
                                disabled={disabled}
                            />
                            <span className="input-group-addon">°С</span>
                        </div>
                    </div>
                    <div className={"col-xs-2 col-sm-1 inline-label" + (this.props.errors.tempConditionHigh ? " has-error" : "")}>
                        до
                    </div>
                    <div className={"col-xs-10 col-sm-5" + (this.props.errors.tempConditionHigh ? " has-error" : "")}>
                        <div className="input-group">
                            <NumberInput id="inputTempConditionHigh"
                                title={this.props.errors.tempConditionHigh}
                                value={this.props.parcel.tempConditionHigh}
                                decimals="0"
                                onChange={value => this.handleInputChange("tempConditionHigh", value)}
                                onEditComplete={() => this.handleFieldEdited("tempConditionHigh")}
                                disabled={disabled}
                            />
                            <span className="input-group-addon">°С</span>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row checkbox">
                    {this.renderTempConditionCheckbox(disabled)}
                </div>
            );
        }
    }

    renderVehicleTypeAndInvoiceNumberControls(vehicleTypeDisabled, invoiceNumberDisabled) {
        if (this.props.isNew) {
            return null;
        } else {
            return (
                <div className="row">
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.vehicleTypeId ? " has-error" : "")}>
                            <label htmlFor="selectVehicleType" title={this.props.errors.vehicleTypeId}>Тип ТС<span className="text-red">*</span></label>
                            <SelectInput id="selectVehicleType"
                                clearable={false}
                                options={this.state.vehicleTypes}
                                value={this.props.parcel.vehicleTypeId}
                                title={this.props.errors.vehicleTypeId}
                                onChange={e => this.handleSelectionChange("vehicleTypeId", e)}
                                disabled={vehicleTypeDisabled}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.invoiceNumber ? " has-error" : "")}>
                            <label htmlFor="inputInvoiceNumber">Счет</label>
                            <TextInput id="inputInvoiceNumber"
                                title={this.props.errors.invoiceNumber}
                                value={this.props.parcel.invoiceNumber}
                                onChange={value => this.handleInputChange("invoiceNumber", value)}
                                onEditComplete={() => this.handleFieldEdited("invoiceNumber")}
                                disabled={invoiceNumberDisabled}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderCarriageDetailsBlock(isBusy, isAuthorEditable, isOnlyBeforeSendEditable, isInvoiceNumberEditable, isExternalNumberEditable) {
        if (this.props.isNew) {
            return (
                <div className="col-sm-6">
                    <div>
                        <h4 className="text-center">Данные перевозки</h4>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className={"form-group" + (this.props.errors.departureDate ? " has-error" : "")}>
                                <label htmlFor="inputDepartureDate" className="single-line-label">
                                    Дата отправки груза<span className="text-red">*</span>
                                </label>
                                {this.renderShipmentDate(isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable)}
                            </div>
                        </div>
                    </div>

                    {this.renderTempConditionControls(isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable)}
                </div>
            );
        } else {
            return (
                <div className="col-sm-6">
                    <div>
                        <h4 className="text-center">Данные перевозки</h4>
                    </div>

                    <div className="row">
                        <div className="col-sm-6">
                            <div className={"form-group" + (this.props.errors.vehicleTypeId ? " has-error" : "")}>
                                <label htmlFor="selectVehicleType" title={this.props.errors.vehicleTypeId}>Тип ТС<span className="text-red">*</span></label>
                                <SelectInput id="selectVehicleType"
                                    clearable={false}
                                    options={this.state.vehicleTypes}
                                    value={this.props.parcel.vehicleTypeId}
                                    title={this.props.errors.vehicleTypeId}
                                    onChange={e => this.handleSelectionChange("vehicleTypeId", e)}
                                    disabled={isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className={"form-group" + (this.props.errors.invoiceNumber ? " has-error" : "")}>
                                <label htmlFor="inputInvoiceNumber">Счет</label>
                                <TextInput id="inputInvoiceNumber"
                                    title={this.props.errors.invoiceNumber}
                                    value={this.props.parcel.invoiceNumber}
                                    onChange={value => this.handleInputChange("invoiceNumber", value)}
                                    onEditComplete={() => this.handleFieldEdited("invoiceNumber")}
                                    disabled={isBusy || !isInvoiceNumberEditable}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-6">
                            <div className={"form-group" + (this.props.errors.urgencyId ? " has-error" : "")}>
                                <label htmlFor="selectUrgency" title={this.props.errors.urgencyId}>Срочность<span className="text-red">*</span></label>
                                <SelectInput id="selectUrgency"
                                    clearable={false}
                                    options={this.state.urgencies}
                                    value={this.props.parcel.urgencyId}
                                    title={this.props.errors.urgencyId}
                                    onChange={e => this.handleSelectionChange("urgencyId", e)}
                                    disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                />
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className={"form-group" + (this.props.errors.departureDate ? " has-error" : "")}>
                                <label htmlFor="inputDepartureDate" className="single-line-label">
                                    Дата отправки груза<span className="text-red">*</span>
                                </label>
                                {this.renderShipmentDate(isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable)}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-6">
                            <div className={"form-group" + (this.props.errors.externalNumber ? " has-error" : "")}>
                                <label htmlFor="inputExternalNumber">Внешний номер посылки</label>
                                <TextInput id="inputExternalNumber"
                                    title={this.props.errors.externalNumber}
                                    value={this.props.parcel.externalNumber}
                                    onChange={value => this.handleInputChange("externalNumber", value)}
                                    onEditComplete={() => this.handleFieldEdited("externalNumber")}
                                    disabled={isBusy || !isExternalNumberEditable}
                                />
                            </div>
                        </div>
                    </div>

                    {this.renderTempConditionControls(isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable)}
                </div>
            );
        }
    }

    render() {
        let isAuthor = getRoles().indexOf('Author') >= 0;
        let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isCarrier = getRoles().indexOf('Carrier') >= 0;
        let isAuthorEditable = this.props.isNew || isAuthor || isCoordinator;
        let isCarrierEditable = getRoles().indexOf('Carrier') >= 0 && this.props.parcel.statusCode !== "Created";
        let isOnlyBeforeSendEditable = this.props.isNew
            || this.props.parcel.statusCode === "Created"
            || (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let isInvoiceNumberEditable = (isCarrier || isCoordinator) && this.props.parcel.statusCode !== "Completed" && this.props.parcel.statusCode !== "Cancelled";
        let isExternalNumberEditable = (isCarrier || isCoordinator)
            && this.props.parcel.statusCode !== "Created" && this.props.parcel.statusCode !== "SentToMailRoom" && this.props.parcel.statusCode !== "Cancelled";
        let isBusy = this.props.isBusy || this.state.busyCount > 0;

        let comments = this.props.isNew ? (
            <div className="row">
                <div className="col-sm-12">
                    <div className={"form-group" + (this.props.errors.senderComment ? " has-error" : "")}>
                        <label htmlFor="inputSenderComment">Комментарий к грузу</label>
                        <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Комментарий к грузу"
                            data-content="Дополнительные сведения о посылке">
                            <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                        </a>
                        <TextInput id="inputSenderComment"
                            title={this.props.errors.senderComment}
                            value={this.props.parcel.senderComment}
                            onChange={value => this.handleInputChange("senderComment", value)}
                            onEditComplete={() => this.handleFieldEdited("senderComment")}
                            disabled={isBusy || !isAuthorEditable}
                        />
                    </div>
                </div>
            </div>
        ) : (
                <div className="row">
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.senderComment ? " has-error" : "")}>
                            <label htmlFor="inputSenderComment">Комментарий к грузу</label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Комментарий к грузу"
                                data-content="Дополнительные сведения о посылке">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <TextInput id="inputSenderComment"
                                title={this.props.errors.senderComment}
                                value={this.props.parcel.senderComment}
                                onChange={value => this.handleInputChange("senderComment", value)}
                                onEditComplete={() => this.handleFieldEdited("senderComment")}
                                disabled={isBusy || !isAuthorEditable}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.carrierComment ? " has-error" : "")}>
                            <label htmlFor="inputSenderComment" className="single-line-label">
                                Комментарий Транспортной компании
						</label>
                            <TextInput id="inputSenderComment"
                                title={this.props.errors.carrierComment}
                                value={this.props.parcel.carrierComment}
                                onChange={value => this.handleInputChange("carrierComment", value)}
                                onEditComplete={() => this.handleFieldEdited("carrierComment")}
                                disabled={isBusy || !isCarrierEditable}
                            />
                        </div>
                    </div>
                </div>
            );

        let packagingCommentSelectInput = null;
        if (this.props.parcel.isPackagingRequested) {
            packagingCommentSelectInput =
                (<div className={"row" + (this.props.errors.packagingComment ? " has-error" : "")}>
                    <div className="col-sm-6">
                        <SelectInput id="selectPackagingComment"
                            clearable={false}
                            options={[{ value: "в офисе", label: "в офисе" }, { value: "на складе КСЭ", label: "на складе КСЭ" }]}
                            value={this.props.parcel.packagingComment}
                            title={'Комментарий к доупаковке'}
                            onChange={e => this.handleSelectionChange("packagingComment", e)}
                            disabled={false}
                        />
                    </div>
                </div>)
        }

        return (
            <div>
                <div className="row">
                    <div className="col-sm-6">
                        <div>
                            <h4 className="text-center">Данные посылки</h4>
                        </div>

                        <div className={"form-group" + (this.props.errors.parcelType ? " has-error" : "")}>
                            <label>Тип посылки<span className="text-red">*</span></label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Тип посылки"
                                data-content="Выберите «Конверт», если посылка помещается в курьерский конверт">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                            <div className="row">
                                <div className="col-sm-offset-1 col-sm-5">
                                    <div className="radio">
                                        <label>
                                            <input type="radio" id="inputParcelTypeDoc"
                                                title={this.props.errors.parcelType}
                                                value={this.state.parcelDocType}
                                                checked={this.props.parcel.parcelType === this.state.parcelDocType}
                                                onChange={e => this.handleParcelTypeChange(e)}
                                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                            />
                                            Конверт
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    <div className="radio">
                                        <label>
                                            <input type="radio" id="inputParcelTypeCargo"
                                                title={this.props.errors.parcelType}
                                                value={this.state.parcelCargoType}
                                                checked={this.props.parcel.parcelType === this.state.parcelCargoType}
                                                onChange={e => this.handleParcelTypeChange(e)}
                                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                            />
                                            Груз
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={"form-group" + (this.props.errors.cargoDescription ? " has-error" : "")}>
                            <label htmlFor="inputCargoDesc">Описание содержимого<span className="text-red">*</span></label>
                            <TextInput id="inputCargoDesc"
                                title={this.props.errors.cargoDescription}
                                value={this.props.parcel.cargoDescription}
                                onChange={value => this.handleInputChange("cargoDescription", value)}
                                onEditComplete={() => this.handleFieldEdited("cargoDescription")}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                maxLength={90}
                            />
                            <small className="control-footer-hint">Максимум 90 символов</small>
                        </div>

                        {this.renderDimensions(isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable)}

                        <div className="row">
                            <div className="col-sm-6">
                                <div className={"form-group" + (this.props.errors.weight ? " has-error" : "")}>
                                    <label htmlFor="inputWeight">Вес<span className="text-red">*</span></label>
                                    <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Вес"
                                        data-content="Вес одного места должен быть не больше 30 кг (50 кг для DHL)">
                                        <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                    </a>
                                    <div className="input-group">
                                        <NumberInput id="inputWeight"
                                            title={this.props.errors.weight}
                                            value={this.props.parcel.weight}
                                            decimals="5"
                                            min="0"
                                            onChange={value => this.handleInputChange("weight", value)}
                                            onEditComplete={() => this.handleFieldEdited("weight")}
                                            disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                        />
                                        <span className="input-group-addon">кг</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className={"form-group" + (this.props.errors.volume ? " has-error" : "")}>
                                    <label htmlFor="inputVolume">Объём<span className="text-red">*</span></label>
                                    <div className="input-group">
                                        <NumberInput id="inputVolume"
                                            title={this.props.errors.volume}
                                            value={this.props.parcel.volume}
                                            decimals="5"
                                            min="0"
                                            disabled
                                        />
                                        <span className="input-group-addon">м<sup>3</sup></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.renderCarriageDetailsBlock(isBusy, isAuthorEditable, isOnlyBeforeSendEditable, isInvoiceNumberEditable, isExternalNumberEditable)}
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div>
                            <h4 className="text-center">
                                Дополнительные услуги
								<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Дополнительные услуги"
                                    data-content="Выберите опции, если они необходимы для вашей посылки. Обратите внимание, что дополнительные услуги могут повлечь за собой дополнительные затраты.">
                                    <small>
                                        <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                    </small>
                                </a>
                            </h4>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6 checkbox-column">
                        <div className="checkbox">
                            <label>
                                <CheckBoxInput id="inputIsLoadingRequested"
                                    title={this.props.errors.isLoadingRequested}
                                    checked={this.props.parcel.isLoadingRequested}
                                    onChange={e => this.handleCheckboxChange("isLoadingRequested", e)}
                                    disabled={isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                />
                                Дополнительная погрузка / Разгрузка
                            </label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Дополнительная погрузка / Разгрузка"
                                data-content="Выберите при крупногабаритном грузе, для которого требуются услуги грузчиков">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                        </div>

                        <div className="row checkbox">
                            <div className="col-xs-12">
                                <label>
                                    <CheckBoxInput id="inputIsValueDeclared"
                                        title={this.props.errors.isValueDeclared}
                                        checked={this.props.parcel.isValueDeclared}
                                        onChange={e => this.handleCheckboxChange("isValueDeclared", e)}
                                        disabled={isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                    />
                                    Объявленная стоимость груза
				                </label>
                                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Объявленная стоимость груза"
                                    data-content="Выберете и внесите в поле стоимость груза, если он является ценным. Груз будет дополнительно застрахован.">
                                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                </a>
                                {this.renderDeclaredCargoValue(isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable)}
                            </div>
                        </div>
                        <div className="row checkbox">
                            <div className="col-xs-12">
                                <label>
                                    <CheckBoxInput id="inputIsSelfDelivery"
                                        checked={this.props.parcel.isSelfDelivery}
                                        onChange={e => this.handleCheckboxChange("isSelfDelivery", e)}
                                        disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                    />
                                    Самостоятельная доставка до ТК (только DHL)
                                </label>
                                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Самостоятельная доставка до ТК"
                                    data-content="Описание для самостоятельной доставки до ТК">
                                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                </a>
                                {this.renderIsSelfDelivery(isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable)}
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 checkbox-column">
                        <div className="checkbox">
                            <label>
                                <CheckBoxInput id="inputIsPackagingRequested"
                                    title={this.props.errors.isPackagingRequested}
                                    checked={this.props.parcel.isPackagingRequested}
                                    onChange={e => this.handleCheckboxChange("isPackagingRequested", e)}
                                    disabled={isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                />
                                Доупаковка (только КСЭ)
                            </label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Доупаковка"
                                data-content="Выберете, если груз недостаточно упакован для безопасной перевозки, комментарий обязателен">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                        </div>

                        {packagingCommentSelectInput}

                        <div className="checkbox">
                            <label>
                                <CheckBoxInput id="inputIsReturnRequested"
                                    title={this.props.errors.isReturnRequested}
                                    checked={this.props.parcel.isReturnRequested}
                                    onChange={e => this.handleCheckboxChange("isReturnRequested", e)}
                                    disabled={isBusy || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                />
                                Доставка с возвратом (только КСЭ)
                            </label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Доставка с возвратом"
                                data-content="Выберете, если необходимо сразу после доставки забрать посылку с того же адреса и вернуть отправителю">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                        </div>

                        <div className="checkbox">
                            <label>
                                <CheckBoxInput id="inputIsProductSending"
                                    title={this.props.errors.isProductSending}
                                    checked={this.props.parcel.isProductSending}
                                    onChange={e => this.handleCheckboxChange("isProductSending", e)}
                                    disabled={isBusy || this.props.parcel.parcelType === this.state.parcelDocType || !isOnlyBeforeSendEditable || !isAuthorEditable}
                                />
                                Содержит продукцию J&J
                            </label>
                            <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Содержит продукцию J&J"
                                data-content="В случае, если в отправке есть продукция JnJ, которая может быть использована потребителями">
                                <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div>
                            <h4 className="text-center">Комментарии</h4>
                        </div>
                    </div>
                </div>

                {comments}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/cargoTab.jsx